import { useWizard } from "../CalendarForm";

/**
 * StepIndicator Component - Light Theme
 * 
 * Displays a visual progress indicator for the wizard.
 * Uses indigo as the primary color to match the app's design system.
 */
export default function StepIndicator() {
  const { currentStep, totalSteps, stepTitles, goToStep } = useWizard();

  const isStepClickable = (stepNumber) => {
    return stepNumber < currentStep;
  };

  return (
    <div className="mb-2">
      <div className="flex items-center justify-center">
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <div key={stepNumber} className="flex items-center">
              {/* Step Circle */}
              <button
                onClick={() => isStepClickable(stepNumber) && goToStep(stepNumber)}
                disabled={!isStepClickable(stepNumber)}
                className={`
                  relative flex items-center justify-center w-10 h-10 rounded-full
                  font-semibold text-sm transition-all duration-300 ease-out
                  ${isCompleted
                    ? "bg-indigo-600 text-white cursor-pointer hover:bg-indigo-500"
                    : isCurrent
                      ? "bg-indigo-600 text-white ring-4 ring-indigo-100"
                      : "bg-gray-200 text-gray-500 cursor-not-allowed"
                  }
                `}
                title={stepTitles[index]}
              >
                {isCompleted ? (
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                ) : (
                  stepNumber
                )}

                {/* Step Label */}
                <span
                  className={`
                    absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap
                    text-xs font-medium transition-colors duration-300
                    ${isCurrent ? "text-indigo-600" : isCompleted ? "text-indigo-600" : "text-gray-400"}
                  `}
                >
                  {stepTitles[index]}
                </span>
              </button>

              {/* Connector Line */}
              {stepNumber < totalSteps && (
                <div
                  className={`
                    w-24 h-1 mx-3 rounded-full transition-colors duration-500
                    ${isCompleted ? "bg-indigo-600" : "bg-gray-200"}
                  `}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}